<template>
  <v-container fluid fill-height>
    <v-layout align-start justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Rejestracja konta</v-toolbar-title>
          </v-toolbar>
          <form class="login" @submit.prevent="registerRunner" novalidate>
            <v-layout>
            <v-card v-if="package" class="name-card trainer-card">
              <v-card-text>
                  <div>
                    <div class="subheading">{{package.name}}</div>
                    <div class="subheading">{{package.price}} zł</div>
                    <div class="caption">{{package.description}}</div>
                  </div>
              </v-card-text>
            </v-card>
            <v-card v-if="trainer" class="name-card trainer-card">
              <v-card-text>
                <div class="layout ma-0 align-center column">
                  <div class="subheading">Wybrany trener</div>
                  <v-avatar size="120" color="primary">
                    <img width="200" v-if="trainer.avatar_thumbnail" :src="trainer.avatar_thumbnail" />
                    <img width="200" v-if="!trainer.avatar_thumbnail" src="@/assets/img/avatar.png" />
                  </v-avatar>
                </div>
                  <div>
                    <div class="subheading">{{trainer.full_name}}</div>
                  </div>
              </v-card-text>
            </v-card>
            </v-layout>

            <v-card-text>
            <Fields
              v-bind="{fields, object: formData, errors: formErrors}">
              <template slot="fieldTos" slot-scope="{error, errorMessages, field}">
                <v-checkbox
                    :key="field.id"
                    v-bind="field.props"
                    v-model="formData.tos"
                    @input="delete errors[field.id]"
                    @change="delete errors[field.id]"
                    :error="error"
                    :error-messages="errorMessages"
                  >
                  <div slot="label">
                    Akceptuję
                    <v-tooltip bottom>
                      <a slot="activator" target="_blank" href="http://inzynieriabiegania.pl/regulamin" @click.stop>regulamin</a>
                      Otwórz w nowym oknie
                    </v-tooltip>
                    *
                  </div>
                </v-checkbox>
              </template>
            </Fields>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary">Zarejestruj</v-btn>
            </v-card-actions>
          </form>
          <v-progress-linear v-if="progress" :indeterminate="true"></v-progress-linear>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {registerRunnerSelf} from './api'
import * as types from '@/store/mutation-types'
import { mapGetters } from 'vuex'
import Fields from '@/forms/Fields'

export default {
  components: {Fields},
  validators: {
  },
  data () {
    return {
      progress: false,
      formErrors: {},
      formData: {},
      trainer: null,
      package: null
    }
  },
  computed: {
    ...mapGetters(['getPackageById', 'getTrainerById']),
    fields () {
      return [
        {comp: 'text', id: 'email', label: 'Email*', props: {prependIcon: 'person'}},
        {comp: 'text', id: 'password1', label: 'Hasło*', props: {type: 'password', prependIcon: 'lock'}},
        {comp: 'text', id: 'password2', label: 'Powtórz hasło*', props: {type: 'password', prependIcon: 'lock'}},
        {comp: 'text', id: 'first_name', label: 'Imię*'},
        {comp: 'text', id: 'last_name', label: 'Nazwisko*'},
        {comp: 'text', id: 'phone', label: 'Telefon*'},
        {comp: 'checkbox', id: 'tos', label: 'Akceptuję regulamin*', props: {}},
        {comp: 'checkbox', id: 'personal_data', label: 'Wyrażam zgodę na przetwarzanie moich danych osobowych w celu realizacji zamówionych przeze mnie usług.*', props: {}},
        {comp: 'checkbox', id: 'health_statement', label: 'Oświadczam, że nie mam przeciwwskazań zdrowotnych do udziału w treningu i mój obecny stan zdrowia pozwala na realizowanie planów treningowych oraz że przystępuję do jego realizacji dobrowolnie i na własną odpowiedzialność. Jednocześnie przyjmuję do świadomości, że trening biegowy wiąże się z wysiłkiem fizycznym i biorę pełną odpowiedzialność za kontuzje z niego wynikające.*', props: {}},
        {comp: 'checkbox', id: 'newsletter', label: 'Chcę otrzymywać newsletter. Zezwalam na przetwarzanie moich danych osobowych w celu przysyłania mi informacji marketingowych', props: {}}
      ]
    }
  },
  created () {
    this.p1 = this.$store.dispatch(types.ALL_PACKAGES_REQUEST)
    this.p2 = this.$store.dispatch(types.ALL_TRAINERS_REQUEST)
  },
  mounted () {
    Promise.all([this.p1, this.p2]).then(() => {
      if (this.$route.query.trainer) {
        let trainer = this.getTrainerById(parseInt(this.$route.query.trainer))
        if (trainer) {
          this.formData.registration_trainer = trainer.id
          this.trainer = trainer
        }
      }
      if (this.$route.query.package) {
        let pck = this.getPackageById(parseInt(this.$route.query.package))
        if (pck) {
          this.formData.registration_package = pck.id
          this.package = pck
          if (this.package.trainer) {
            let trainer = this.getTrainerById(this.package.trainer)
            this.trainer = trainer
            this.formData.registration_trainer = trainer.id
          }
        }
      }
    })
  },
  methods: {
    registerRunner () {
      this.$validate().then(success => {
        if (success) {
          this.progress = true
          registerRunnerSelf(this.formData).then((data) => {
            this.formData = {}
            this.validation.reset()
            this.$router.push({name: 'registration-completed'})
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          }).finally(() => {
            this.progress = false
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.trainer-card.v-card.name-card {
  width: 20%;
  margin: auto;
  margin-top: 20px;
  display: flex;
  min-width: 250px;
  flex-direction: column;
  justify-content: space-between;

  &.selected {
    background: #0277bd;
    color: white;
  }

  .subheading {
    margin: 20px 0px;
    text-align: center;
  }
  .caption {
    white-space: pre-wrap;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/auth/RunnerSelfRegister.vue